const Approval = () => import(/* webpackPrefetch: true */ '@/views/private/approval/Index.vue')
const Discount = () => import(/* webpackPrefetch: true */ '@/components/approval/Discount.vue')
const Other = () => import(/* webpackPrefetch: true */ '@/components/approval/Other.vue')
const DP = () => import(/* webpackPrefetch: true */ '@/components/approval/DP.vue')
const Booking = () => import(/* webpackPrefetch: true */ '@/components/approval/Booking.vue')

const routes = [
  {
    path: "/approval",
    name: "approval",
    component: Approval,
    meta: {
      title: "Persetujuan"
    },
    children: [
      {
        path: '/approval/discount',
        name: 'approval discount',
        component: Discount,
        meta: {
          title: "Persetujuan Diskon Booking"
        }
      },
      {
        path: '/approval/other',
        name: 'approval other',
        component: Other,
        meta: {
          title: "Persetujuan Biaya Lain-lain"
        }
      },
      {
        path: '/approval/dp',
        name: 'approval dp',
        component: DP,
        meta: {
          title: "Persetujuan Down Payment"
        }
      },
      {
        path: '/approval/booking',
        name: 'approval booking',
        component: Booking,
        meta: {
          title: "Persetujuan Pembatalan Booking"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})